class ApiServerError extends Error {
  constructor(status, payload) {
    super();
    this.name = 'ApiServerError';
    this.error = payload;
    this.status = status;
  }
}
export default ApiServerError;



// WEBPACK FOOTER //
// ./src/state/services/ApiServiceError.js